import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { withRouter, Redirect } from 'react-router-dom';
// import { addUrlProps, UrlQueryParamTypes, subquery } from 'react-url-query';

import { isEqual, isEmpty, get } from 'lodash-es';

import { SortDirection } from 'react-virtualized';

import { CircularProgress, ListItem, MenuButton } from 'react-md';

import Immutable from 'immutable';

import { CoogTable } from '@coog/react-components';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { theme } from '../../Theme/theme';

import * as quotationsActions from '../../Services/Quotations/actions';
import * as productsActions from '../../Services/Products/actions';

import { applyFilters, defaultFiltersProps } from './filters';

import {
  columns,
  filtersUI,
  // statusOptions
} from './config';

import { stringifyQuery, parseQuery } from '../../Utils/Utils';

import './Quotations.scss';

import FilterControls from '../../Components/Filter/FilterControls';

class Quotations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: false,
      redirectTo: undefined,
      list: undefined,
      filteredList: undefined,
      filters: props.filters,
    };
  }

  // eslint-disable-next-line no-unused-vars
  static getDerivedStateFromProps(nextProps, prevState) {
    const { list: nextList } = nextProps;
    const { list: prevList } = prevState;
    let newState = null;

    if (nextList && !!nextList.toJS && !Immutable.is(prevList, nextList)) {
      newState = {
        list: nextList, // TODO add filtering statement...
      };
    }

    return newState;
  }

  componentDidMount() {
    const self = this;
    const { actions, list, location, history, filters: defaultFilters, system } = self.props;
    // const { filteredList } = self.state;
    actions.fetchCommercialProducts({ date: new Date(), dateFormat: system.dateFormat });
    actions.fetchQuotations();
    // Filters
    const filters = isEmpty(parseQuery(location.search)) ? defaultFilters : parseQuery(location.search);
    self.setState({ filters });
    history.push({
      pathname: location.pathname,
      search: stringifyQuery(filters),
    });
    if (list) {
      self.filter({ list, ref: 'componentDidMount', filters });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const self = this;
    const { filters: prevFilters } = prevState;
    const { list, location } = self.props;
    //
    if (!Immutable.is(prevProps.list, list)) {
      if (typeof list !== 'undefined' && !Immutable.is(prevState.list !== list)) {
        self.filter({ list, ref: 'componentDidUpdate1' });
      }
    }
    // Filters
    const filters = prevFilters || parseQuery(location.search);
    if (typeof list !== 'undefined' && filters && !isEqual(prevFilters, filters)) {
      self.setState({ filters });
      self.filter({ list, ref: 'componentDidUpdate2' });
    }
  }

  handleFiltersChange = filters => {
    const { list, history, location } = this.props;
    history.push({
      pathname: location.pathname,
      search: stringifyQuery(filters),
    });
    this.setState({ filters });
    this.filter({ list, ref: 'handleFiltersChange', filters });
  };

  filter = ({ list, /* ref, */ filters: newFilters }) => {
    const { filters } = this.state;
    const filteredList = applyFilters({ list, filters: newFilters || filters });
    // eslint-disable-next-line react/no-did-update-set-state
    this.setState({ filteredList });
  };

  // eslint-disable-next-line no-unused-vars
  handleGetRoute = ({ route = '', action, type, id = '' }) => {
    this.setState({
      redirect: true,
      redirectTo: `${route}${id}`,
    });
  };

  handleAction = ({ route, action, type, id }) => {
    const { actions } = this.props;
    if (type === 'action') {
      switch (action) {
        case 'cancel':
          actions.cancelQuotation({ id });
          break;
        default:
          break;
      }
    } else {
      this.handleGetRoute({ route, action, type, id });
    }
  };

  render() {
    const { redirect, redirectTo, list, filteredList, filters } = this.state;
    const { system, loading } = this.props;
    if (redirect) return <Redirect push to={redirectTo} />;

    if (!get(loading, 'isLocaleLoaded')) return <></>;

    const { pageTitle, canonical, strings, commercialproducts } = this.props;

    const helmet = (
      <Helmet>
        <meta charSet="utf-8" />
        <title>{strings[pageTitle] || 'Tarifications'}</title>
        <meta name="description" content={strings[pageTitle] || 'Tarifications'} />
        <link rel="canonical" href={canonical} />
      </Helmet>
    );

    const quotations = () =>
      list && filteredList ? (
        <MuiThemeProvider theme={theme}>
          <CoogTable
            defaultSorted={{ sortBy: 'createdOn', sortDirection: SortDirection.DESC }}
            rows={filteredList}
            columns={columns(this.handleAction, strings, system.i18n)}
            strings={strings}
            uid="id"
            onClickCellAction={this.handleAction}
          />
        </MuiThemeProvider>
      ) : (
        <CircularProgress id="quotations-loading" className="loading" scale={3} style={{ margin: '2em auto' }} />
      );

    return (
      <div className="coog-app quotations">
        {helmet}
        <div className="blocks-header">
          <h1 className="md-title md-cell md-cell--12">{strings[pageTitle] || 'Tarifications'}</h1>
          <div className="blocks-actions">
            {/* <Button flat primary className="icon-text-btn" iconBefore={false} iconChildren="add">Ajouter un tarification</Button> */}
            {/* <Button flat primary className="text-btn">Ajouter un tarification</Button> */}
            {/* <Button
              floating
              primary
              swapTheming
              tooltipLabel={strings['quotations.actions.newquotation.btn.label'] || 'Ajouter une tarification'}
              tooltipPosition="left"
              // onClick={() => this.handleGetRoute({ route: '/quotations/new' })}
              onClick={() => this.handleGetRoute({ route: '/surveys/new' })}
            >
              add
            </Button> */}
            {/* <MenuButton
              id="add-quotation"
              floating
              secondary
              raised
              menuItems={[
                <ListItem
                  key={1}
                  primaryText={strings['quotations.actions.newquotation.btn.label'] || 'Nouvelle tarification'}
                  onClick={() => this.handleGetRoute({ route: '/quotations/new' })}
                />,
                <ListItem
                  key={2}
                  primaryText={strings['quotations.actions.newsurvey.btn.label'] || "Outil d'aide à la vente"}
                  onClick={() => this.handleGetRoute({ route: '/surveys/new' })}
                />,
              ]}
              anchor={{ x: MenuButton.HorizontalAnchors.CENTER, y: MenuButton.VerticalAnchors.TOP }}
              simplifiedMenu={false}
              repositionOnScroll={false}
              tooltipLabel={strings['quotations.actions.newquotation.btn.label'] || 'Ajouter une tarification'}
              tooltipPosition="left"
            >
              add
            </MenuButton> */}
          </div>
        </div>
        {/* <Divider /> */}
        <div className="block-controls">
          {filteredList ? (
            <div className="block-info">
              <span className="value">{filteredList.size}</span>
              <span className="label">{strings['quotations.controls.info.label'] || 'tarification(s) trouvée(s)'}</span>
            </div>
          ) : (
            undefined
          )}
          <FilterControls
            id="quotations-filters-block"
            key="quotations-filters-block"
            strings={strings}
            filters={filters}
            onFiltersChange={this.handleFiltersChange}
            filtersUI={filtersUI({ strings, commercialproducts })}
          />
        </div>
        <div className="md-body md-cell md-cell--12">{quotations()}</div>
      </div>
    );
  }
}

Quotations.propTypes = {
  actions: PropTypes.shape({
    fetchQuotations: PropTypes.func,
    cancelQuotation: PropTypes.func,
    fetchCommercialProducts: PropTypes.func,
  }).isRequired,
  strings: PropTypes.objectOf(PropTypes.string),
  pageTitle: PropTypes.string,
  canonical: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  list: PropTypes.instanceOf(Immutable.List),
  // eslint-disable-next-line
  match: PropTypes.object.isRequired,
  // eslint-disable-next-line
  location: PropTypes.object.isRequired,
  // eslint-disable-next-line
  history: PropTypes.object.isRequired,
  // eslint-disable-next-line
  filters: PropTypes.object,
  // eslint-disable-next-line
  commercialproducts: PropTypes.array,
  // eslint-disable-next-line
  system: PropTypes.object,
  // eslint-disable-next-line
  loading: PropTypes.object,
};

Quotations.defaultProps = {
  pageTitle: 'title.quotation.list',
  canonical: 'http://www.coopengo.com/',
  strings: {},
  list: undefined,
  filters: {
    query: '',
    status: ['submitted', 'project', 'pending'],
    commercialProductId: [],
  },
  commercialproducts: undefined,
  system: undefined,
};
// eslint-disable-next-line no-unused-vars
const mapStateToProps = state => {
  const quotations = state.getIn(['quotations']).toJS();

  return {
    strings: get(quotations, 'strings', {}),
    list: state.getIn(['quotations', 'list']),
    filters: get(quotations, 'filters', defaultFiltersProps),
    commercialproducts: state.toJS().products.commercialproducts,
    system: state.toJS().system,
    loading: get(quotations, 'loading', {}),
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...quotationsActions, ...productsActions }, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Quotations));
